import { FC, ReactNode } from "react";
import { Button, Flex, Icon, Image, Text } from "@chakra-ui/react";

import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";
import secureUpload from "@assets/files/images/cases/secureUpload.png";
import Bag from "@assets/files/images/icons/bag.svg?react";

const SecureUploadNote: FC = () => (
  <Text fontSize="13px" color="brand.emptyStateText">
    <Icon as={Bag} w="18px" h="18px" verticalAlign="text-bottom" />
    &nbsp;
    <Text as="span" fontWeight={FONT_WEIGHT.BOLD} color="brand.textSecondary">
      FULLY SECURED
    </Text>{" "}
    SSL Upload
  </Text>
);

export const SslSecuredNote: FC = () => (
  <Text fontSize="12px" color="brand.emptyStateText">
    <Icon as={Bag} w="16px" h="16px" verticalAlign="text-bottom" />
    &nbsp;SSL secured
  </Text>
);

interface CaseDocumentDropZoneProps {
  title: string;
  formatNames: string[];
  limits: ReactNode;
  note?: ReactNode;
}

const CaseDocumentDropZone: FC<CaseDocumentDropZoneProps> = ({ title, formatNames, limits, note }) => (
  <Flex
    direction="column"
    align="center"
    gap="10px"
    px="28px"
    py="34px"
    borderRadius="10px"
    border="1.5px dashed"
    borderColor="gray.200"
    bg="brand.bg"
    textAlign="center"
    cursor="pointer"
  >
    <Image src={secureUpload} alt="secure upload" />
    <Text mt={4} fontSize="20px" color="brand.modalHeaderText">
      {title}
    </Text>
    <Text fontSize="14px" color="brand.emptyStateText">
      Supported formats:{" "}
      <Text as="span" fontWeight={FONT_WEIGHT.HEAVY} color="brand.textSecondary">
        {formatNames.join(", ")}
      </Text>
    </Text>
    {note && (
      <Text
        maxW="520px"
        fontSize="13px"
        lineHeight={1.55}
        color="brand.emptyStateText"
        css={{ "& span": { color: "brand.textSecondary" } }}
      >
        {note}
      </Text>
    )}
    <Button asChild variant="primary" mt={2} px="60px" h="48px" fontSize="17px">
      <span>Browse</span>
    </Button>
    <Text fontSize="13px" color="brand.emptyStateText">
      {limits}
    </Text>
    <SecureUploadNote />
  </Flex>
);

export default CaseDocumentDropZone;
